module.exports = __webpack_public_path__ + "img/kin4.51fea918.jpg";